import {Config} from "./config-viewmodel";
import {IActivity} from "./activities-viewmodel";

export interface MyStudyChoiceActivitiesState {
    loading: boolean,
    config: Config,
    activities: Array<IActivity>,
    activities_retrieved: boolean
}

export class WidgetState implements MyStudyChoiceActivitiesState {
    loading: boolean = false
    config: Config = {
        labels: {
            activityChoiceTitle: '',
            availableActivities: '',
            subscribedActivities: '',
            emptyAvailableActivities: '',
            emptySubscribedActivities: '',
            loading: '',
            signUpButton: '',
            signOutButton: '',
            route: '',
            viewingAndEditingSessions: '',
            saveDate: '',
            attendedActivityTitle: '',
            viewOrPrintActivities: '',
            completeTheSurvey: '',
            campusOnline: '',
            watchNowLive: ''
        },
        ciamId: '',
        language: '',
        attendedActivitiesOverviewUrl: '',
    }
    activities: IActivity[] = [];
    activities_retrieved: boolean = false
}
